/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { animationUtils } from 'src/components/base';
import { get } from '../map';
import { StyledElement } from './styles';

export const SCROLL_DURATION = 200;

export class ScrollLink extends React.Component<ScrollLinkProps> {
  static defaultProps = {
    component: 'span',
    shouldScroll: () => true,
    calculateOffset: () => 0,
    children: null,
    direction: 'both',
    animate: true,
    onClick: () => {},
    className: '',
  };

  scrollTo(domElement: HTMLElement) {
    const { direction, animate } = this.props;
    if (!domElement) {
      return;
    }

    const offset = this.props.calculateOffset();
    const from = window.pageYOffset;
    const to = domElement.offsetTop - offset;

    if (direction === 'up' && from < to) {
      return;
    }

    if (direction === 'down' && from > to) {
      return;
    }

    // Init scroll animation.
    animationUtils.tween({
      from,
      to,
      duration: animate ? SCROLL_DURATION : 0,
      onUpdate(value) {
        window.scrollTo(0, Math.round(value));
      },
    });
  }

  onClickHandler = (e: React.MouseEvent<HTMLElement>) => {
    this.props.onClick(e);

    let contains = true;
    let current: HTMLElement | null = e.target as HTMLElement;

    while (contains) {
      contains = Boolean(current && e.currentTarget.contains(current));

      // Exit while loop if we should scroll
      if (current && this.props.shouldScroll(current)) {
        const ele = get(this.props.to);
        if (ele) {
          this.scrollTo(ele);
        }

        break;
      }

      current = current && (current.parentNode as HTMLElement);
    }
  };

  render() {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <StyledElement
        className={`${'pj-ui-scroll-link'} ${this.props.className}`}
        onClick={this.onClickHandler}
        as={this.props.component}
      >
        {this.props.children}
      </StyledElement>
    );
  }
}

interface ScrollLinkProps {
  to: string;
  component:
    | keyof JSX.IntrinsicElements
    | React.ComponentType<
        React.PropsWithChildren<React.PropsWithChildren<any>>
      >;
  shouldScroll: (element: HTMLElement) => boolean;
  calculateOffset: () => number;
  children: React.ReactNode;
  direction: 'up' | 'down' | 'both';
  animate: boolean;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  className: string;
}
